import SigninWidget from '@digital-development/signin-widget';
import './Signin.css';

declare global {
  interface keepalive {
    checkForKeepalive: () => boolean;
  }
  interface utilities {
    checkHTTPS: () => void;
  }
}

declare let Keepalive: keepalive;
declare let Utilities: utilities;

const Signin: React.FC = (): JSX.Element => {
  Utilities.checkHTTPS();

  const forwardUrl = new URLSearchParams(window.location.search).get(
    'forwardUrl'
  );

  let forwardingUrl = '';
  if (forwardUrl !== null) {
    const re = new RegExp(
      /^((?:(?:(?:\w[.\-+]?)*)\w)+)((?:(?:(?:\w[.\-+]?){0,62})\w)+)\.(\w{2,6})$/
    );
    if (forwardUrl.match(re)) {
      forwardingUrl = '/myrewards/profile/#myrewards';
    } else {
      forwardingUrl = forwardUrl;
    }
  }

  let isValidSession: boolean = true;
  try {
    //check to see if local storage enabled
    if (localStorage) {
      isValidSession = Keepalive.checkForKeepalive();
    }

    if (!isValidSession) {
      if (sessionStorage.getItem('isChallengeActive') !== null) {
        sessionStorage.removeItem('isChallengeActive');
      }
      if (sessionStorage.getItem('linkedAccounts') !== null) {
        sessionStorage.removeItem('linkedAccounts');
      }

      if (forwardingUrl === null || forwardingUrl === '') {
        if (!sessionStorage['lastRequestedURL']) {
          forwardingUrl = '/myrewards/profile/#myrewards';
        } else {
          forwardingUrl = sessionStorage['lastRequestedURL'];
        }
      }
    } else {
      window.location.href = '/myrewards/profile/#myrewards';
    }
  } catch (e) {
    //ignore exception
  }

  return (
    <div className="signin-container">
      <SigninWidget
        forwardUrl={forwardingUrl}
        clearMsgURL="/myrewards/profile/signin"
        sendLinkstoSameTab={true}
      ></SigninWidget>
    </div>
  );
};
export default Signin;
